import Vue from 'vue'
import VueResource from 'vue-resource';
import VueScroll from 'vue-scroll';
import VueKatex from 'vue-katex'
import VueRouter from 'vue-router';
import VueLocalStorage from 'vue-localstorage';

import 'katex/dist/katex.min.css';

import App from './App.vue';
import Create from './components/Create.vue';
import Editor from './components/Editor.vue';

Vue.config.productionTip = false

require('./less/global.less');

Vue.use(VueResource);
Vue.use(VueScroll);
Vue.use(VueKatex);
Vue.use(VueRouter);
Vue.use(VueLocalStorage, {name: 'ls'});

Vue.component('editor', Editor);

const routes = [
    {name: 'home', path: '/', component: Create},
    {name: 'formula', path: '/:uuid', component: Create}
];

const render = h => h(App);
const router = new VueRouter({routes, mode: 'history'});

new Vue({render, router}).$mount('#app');
